import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";

const API_BASE = process.env.REACT_APP_API_BASE;

const ResetPassword = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState("");

  const email = localStorage.getItem("resetEmail");

  useEffect(() => {
    if (!email) navigate("/forgot-password");
  }, [email, navigate]);

  const validatePassword = (pass) => {
    if (pass.length < 6) return "Must be at least 6 characters.";
    if (!/[A-Z]/.test(pass)) return "Must include one uppercase letter.";
    if (!/[!@#$%^&*]/.test(pass)) return "Must include one special character.";
    return "";
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!otp.trim() || !newPassword.trim() || !confirm.trim()) {
      setMessage("Please fill all fields.");
      return;
    }

    const check = validatePassword(newPassword);
    if (check) {
      setMessage(check);
      return;
    }

    if (newPassword !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/user/reset-password`, {
        email,
        otp,
        newPassword,
      });

      localStorage.removeItem("resetEmail");
      setMessage("Password updated! Redirecting…");
      setTimeout(() => navigate("/login"), 900);
    } catch (err) {
      console.error("❌ reset-password error:", err);
      setMessage(err.response?.data?.message || "Reset failed. Try again.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">
            Reset password
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Enter the code from your email and choose a new password
          </p>
        </div>

        <form onSubmit={handleReset} className="space-y-4">
          <input
            type="text"
            placeholder="6-digit code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <div className="relative">
            <input
              type={showNew ? "text" : "password"}
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <span
              className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer text-gray-400"
              onClick={() => setShowNew(!showNew)}
            >
              {showNew ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <div className="relative">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <span
              className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer text-gray-400"
              onClick={() => setShowConfirm(!showConfirm)}
            >
              {showConfirm ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Update password
          </button>
        </form>

        {message && <p className="text-sm text-red-500 text-center">{message}</p>}

        <button
          onClick={() => navigate("/login")}
          className="w-full text-sm text-indigo-600 font-medium hover:underline mt-2"
        >
          Back to login
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
